module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-container container",
    attrs: {
      "id": "flexbox"
    }
  }, [_c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "elevated-box \n                center-align\n                control-panel"
  }, [_c('h3', [_vm._v("Welcome to FlexBox")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "button-container"
  }, [_c('a', {
    staticClass: "btn-floating \n                waves-effect \n                waves-light \n                btn-custom",
    on: {
      "click": function($event) {
        _vm.addItem()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")])]), _vm._v(" "), _c('a', {
    staticClass: "btn-floating \n                waves-effect \n                waves-light \n                btn-custom",
    on: {
      "click": function($event) {
        _vm.removeItem()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("remove")])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-controls"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s6"
  }, [_c('custom-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedProp),
      expression: "selectedProp"
    }],
    domProps: {
      "value": (_vm.selectedProp)
    },
    on: {
      "input": function($event) {
        _vm.selectedProp = $event
      }
    }
  }, [_c('label', {
    staticClass: "default",
    slot: "label"
  }, [_vm._v("Flex Property")]), _vm._v(" "), _vm._l((_vm.flexProps), function(flexProp, propName) {
    return _c('option', {
      slot: "options"
    }, [_vm._v(_vm._s(propName))])
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "col s6"
  }, [_c('custom-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flexProps[_vm.selectedProp].selection),
      expression: "flexProps[selectedProp].selection"
    }],
    domProps: {
      "value": (_vm.flexProps[_vm.selectedProp].selection)
    },
    on: {
      "input": function($event) {
        _vm.flexProps[_vm.selectedProp].selection = $event
      }
    }
  }, [_c('label', {
    staticClass: "default",
    slot: "label"
  }, [_vm._v("Value")]), _vm._v(" "), _vm._l((_vm.flexProps[_vm.selectedProp].values), function(val) {
    return _c('option', {
      slot: "options"
    }, [_vm._v(_vm._s(val))])
  })], 2)], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-container"
  }, [_c('div', {
    staticClass: "flex-box",
    style: (_vm.flexBoxStyles)
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "flex-item animated fadeInLeft",
      class: ['flex-item-' + index]
    }, [_vm._v("\n        .flex-item-" + _vm._s(index) + "\n      ")])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c13695fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flexbox/flexbox.vue
// module id = 19
// module chunks = 0